<template>
	<div class="combined-report">
		<v-layout row wrap fill-height>
			<v-flex xs12 class="menu-column hidden-xs-and-down">
				<Header />
			</v-flex>

			<v-flex xs12 class="div-container-combined">
				<v-layout row wrap>
					<v-flex xs12 sm12 md12>
						<div class="div-container-selects">
							<div class="div-container-filters">
								<date-range-picker :startDate="startDate" :endDate="endDate" presets="Mmty"
									@select="date_range_select"></date-range-picker>
								<select-plus label="Anunciantes" noDataText="Nenhum anunciante" itemName="anunciante"
									:items="advertiserList" v-model="selectedAdvertisers" itemText="reg_name"
									returnObject />
								<select-plus :items="statusDict" item-text="name" v-model="selectedStatus"
									label="Estado (Vendas)" noDataText="Nenhum estado" itemName="estado"
									returnObject></select-plus>
							</div>
							<div class="div-container-filters-button">
								<button :disabled="!!loading" v-on:click="load_all_reports"
									class="button-generate-note">
									<v-icon class="material-icons-outlined" size="40">bolt</v-icon>
									<p>Gerar relatório</p>
								</button>
							</div>
						</div>
					</v-flex>
				</v-layout>

				<v-layout row wrap v-if="loading">
					<v-flex xs12 sm12 md12 class="div-loading-circle">
						<v-progress-circular indeterminate></v-progress-circular>
					</v-flex>
				</v-layout>

				<div v-if="!loading && initialReportGenerated">

					<h2 class="report-section-title">Dashboard</h2>
					<v-layout row wrap>
						<v-flex xs12 sm12 md12>
							<div class="div-container-view">
								<div class="div-container-boxOne">
									<div>
										<p class="paragrafo-title">Vendas aprovadas</p>
										<p class="paragrafo-subtitle">Valor de vendas aprovadas</p>
										<p class="paragrafo-price-approved">
											{{ to_reais(affSummaryRaw.purchases_approved_value, 2) }}</p>
									</div>
									<div>
										<p class="paragrafo-title">Pedidos aprovados</p>
										<p class="paragrafo-subtitle">Quantidade de pedidos aprovados</p>
										<p class="paragrafo-price-approved">
											{{ add_thousands_sep(affSummaryRaw.purchases_approved_count) }}</p>
									</div>
								</div>
								<div class="div-container-boxTwo">
									<div>
										<p class="paragrafo-title">Comissão das vendas</p>
										<p class="paragrafo-subtitle">Valor de comissão aprovada</p>
										<p class="paragrafo-price-approved">
											{{ to_reais(affSummaryRaw.purchases_approved_commission, 2) }}</p>
									</div>
									<div>
										<p class="paragrafo-title">Tráfego gerado</p>
										<p class="paragrafo-subtitle">Quantidade de visitas geradas</p>
										<p class="paragrafo-price-approved">{{ add_thousands_sep(affSummaryRaw.views) }}
										</p>
									</div>
								</div>
							</div>
							<div class="div-container-view">
								<div class="div-container-boxOne">
									<div>
										<p class="paragrafo-title">Vendas pendentes</p>
										<p class="paragrafo-subtitle">Valor de vendas pendentes</p>
										<p class="paragrafo-price-issued">
											{{ to_reais(affSummaryRaw.purchases_issued_value, 2) }}</p>
									</div>
									<div>
										<p class="paragrafo-title">Pedidos pendentes</p>
										<p class="paragrafo-subtitle">Quantidade de pedidos pendentes</p>
										<p class="paragrafo-price-issued">
											{{ add_thousands_sep(affSummaryRaw.purchases_issued_count) }}</p>
									</div>
								</div>
								<div class="div-container-boxTwo">
									<div>
										<p class="paragrafo-title">Comissão pendente</p>
										<p class="paragrafo-subtitle">Valor de comissões pendente</p>
										<p class="paragrafo-price-issued">
											{{ to_reais(affSummaryRaw.purchases_issued_commission, 2) }}</p>
									</div>
									<div>
										<p class="paragrafo-title">Comissões estornadas</p>
										<p class="paragrafo-subtitle">Valor de comissão estornada</p>
										<p class="paragrafo-price-reversal">
											{{ to_reais(affSummaryRaw.reversals_commission, 2) }}</p>
									</div>
								</div>
							</div>
							<div class="div-container-view">
								<div class="div-container-boxOne">
									<div>
										<p class="paragrafo-title">Ticket médio</p>
										<p class="paragrafo-subtitle">Valor médio dos pedidos</p>
										<p class="paragrafo-price-approved">
											{{ to_reais(affSummaryRaw.purchases_approved_avg_value, 2) }}</p>
									</div>
									<div>
										<p class="paragrafo-title">Aprovação dos pedidos</p>
										<p class="paragrafo-subtitle">Taxa de aprovação dos pedidos</p>
										<p class="paragrafo-price-approved">
											{{ formate_percent_value(affSummaryRaw.purchases_approved_rate) }}</p>

									</div>
								</div>
								<div class="div-container-boxTwo">
									<div>
										<p class="paragrafo-title">Ganho por clique (EPC)</p>
										<p class="paragrafo-subtitle">Valor recebido por clique</p>
										<p class="paragrafo-price-approved">{{ to_reais(affSummaryRaw.earn_per_click,
											3) }}</p>
									</div>
									<div>
										<p class="paragrafo-title">Conversão</p>
										<p class="paragrafo-subtitle">Taxa de conversão (pedidos/tráfego)</p>
										<p class="paragrafo-price-approved">
											{{ formate_percent_value(affSummaryRaw.purchase_view_rate) }}</p>
									</div>
								</div>
							</div>
						</v-flex>
					</v-layout>

					<v-divider class="my-4"></v-divider>

					<h2 class="report-section-title">Relatório de Vendas</h2>
					<div class="div-container-dataTable-purchases full-width-report-table">
						<v-data-table :headers="purchasesHeaders" :items="purchasesItems" :total-items="totalPurchases"
							class="elevation-10" rows-per-page-text="Itens por página"
							:rows-per-page-items="[10, 100, 500]" no-data-text="Sem conversões a exibir"
							:custom-sort="custom_sort" :loading="purchasesDataLoading"
							:pagination.sync="purchasesPagination">
							<v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
							<template slot="items" slot-scope="props">
								<td class="font-weight-black">{{ props.item.dtstring }}</td>
								<td class="text-xs-left">{{ props.item.advertiser_name }}</td>
								<td class="text-xs-left">{{ props.item.campaign_name }}</td>
								<td class="font-weight-black text-xs-left">
									<span v-if="props.item.status_string == 'Aprovado'"
										style="color: #40DA99 !important">
										{{ props.item.value_string }}
									</span>
									<span v-else-if="props.item.status_string == 'Pendente'"
										style="color: #5191F2 !important">
										{{ props.item.value_string }}
									</span>
									<span v-else-if="props.item.status_string == 'Cancelado'"
										style="color: #EA4D4D !important">
										{{ props.item.value_string }}
									</span>
									<span v-else-if="props.item.status_string == 'Estornado'"
										style="color: #F6851D !important">
										{{ props.item.value_string }}
									</span>
									<span v-else class="purple--text">
										{{ props.item.value_string }}
									</span>
								</td>
								<td class="font-weight-black text-xs-left">
									<span v-if="props.item.status_string == 'Aprovado'"
										style="color: #40DA99 !important">
										{{ props.item.affiliate_commission_string }}
									</span>
									<span v-else-if="props.item.status_string == 'Pendente'"
										style="color: #5191F2 !important">
										{{ props.item.affiliate_commission_string }}
									</span>
									<span v-else-if="props.item.status_string == 'Cancelado'"
										style="color: #EA4D4D !important">
										{{ props.item.affiliate_commission_string }}
									</span>
									<span v-else-if="props.item.status_string == 'Estornado'"
										style="color: #F6851D !important">
										{{ props.item.affiliate_commission_string }}
									</span>
									<span v-else class="purple--text">
										{{ props.item.affiliate_commission_string }}
									</span>
								</td>
								<td class="font-weight-black text-xs-left">
									<span v-if="props.item.status_string == 'Aprovado'"
										style="color: #40DA99 !important">
										{{ props.item.status_string }}
									</span>
									<span v-else-if="props.item.status_string == 'Pendente'"
										style="color: #5191F2 !important">
										{{ props.item.status_string }}
									</span>
									<span v-else-if="props.item.status_string == 'Cancelado'"
										style="color: #EA4D4D !important">
										{{ props.item.status_string }}
									</span>
									<span v-else-if="props.item.status_string == 'Estornado'"
										style="color: #F6851D !important">
										{{ props.item.status_string }}
									</span>
									<span v-else class="purple--text">
										{{ props.item.status_string }}
									</span>
								</td>
								<td class="text-xs-left">{{ props.item.ref_order }}</td>
								<td class="text-xs-left" v-if="includeMgfKeysPurchases">
									{{ props.item.mgf_keys }}
								</td>
							</template>
						</v-data-table>
					</div>
					<csv-export-button v-show="purchasesItems.length > 0" :attr_names="csvAttrNames"
						:column_names="csvColumnNames" :data="downloadableData"
						:filename="csvFileName"></csv-export-button>

					<v-divider class="my-4"></v-divider>

					<h2 class="report-section-title">Relatório de Visitas</h2>
					<v-layout row wrap>
						<v-flex xs12 sm12 md12>
							<div class=div-container-card-quant-visits>
								<p class="paragrafo-title">Tráfego gerado</p>
								<p class="paragrafo-subtitle">Quantidade de visitas</p>
								<p class="paragrafo-value">{{ add_thousands_sep(totalVisits) }}</p>
							</div>
						</v-flex>
					</v-layout>
					<div class="div-container-dataTable-visits full-width-report-table">
						<v-data-table :headers="visitsHeaders" :items="visitsItems" class="elevation-10"
							rows-per-page-text="Itens por página" :rows-per-page-items="[10, 100, 500]"
							no-data-text="Sem visitas a exibir" :loading="visitsDataLoading" :total-items="totalVisits"
							:pagination.sync="visitsPagination">
							<v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
							<template slot="items" slot-scope="props">
								<td class="font-weight-black">{{ props.item.dtstring }}</td>
								<td class="text-xs-left">{{ props.item.advertiser_name }}</td>
								<td class="font-weight-black text-xs-left">
									{{ props.item.campaign_name }}
								</td>
								<td class="text-xs-left">{{ props.item.ref_uri }}</td>
								<td class="text-xs-left" v-if="includeMgfKeysVisits">
									{{ props.item.mgf_keys }}
								</td>
							</template>
						</v-data-table>
					</div>

				</div>

			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import dayjs from 'dayjs'
import { affiliate_api } from '@/api'
import Header from '../components/Header.vue'
import DateRangePicker from 'magafilio-vue/components/DateRangePicker'
import SelectPlus from 'magafilio-vue/components/SelectPlus'
import CsvExportButton from 'magafilio-vue/components/CsvExportButton'

export default {
	name: 'CombinedReport',
	mixins: [affiliate_api],
	components: {
		Header,
		DateRangePicker,
		SelectPlus,
		CsvExportButton,
	},
	data() {
		return {
			// --- GERAL ---
			loading: false,
			initialReportGenerated: false, // Controla se a busca inicial já foi feita
			canRefresh: false, // Para habilitar watchers de paginação
			startDate: dayjs().startOf('day'),
			endDate: dayjs().endOf('day'),
			selectedAdvertisers: [],
			selectedStatus: [], // Filtro de status para Vendas
			statusDict: [
				{ id: 'issued', name: 'Pendente' },
				{ id: 'approved', name: 'Aprovado' },
				{ id: 'cancelled', name: 'Cancelado' },
				{ id: 'denied', name: 'Estornado' },
			],

			// --- DADOS DO DASHBOARD ---
			affSummaryRaw: {
				purchases_approved_count: 0,
				purchases_approved_value: 0.0,
				purchases_approved_avg_value: 0.0,
				purchases_approved_commission: 0.0,
				purchases_issued_count: 0,
				purchases_issued_value: 0.0,
				purchases_issued_commission: 0.0,
				reversals_count: 0,
				reversals_value: 0.0,
				reversals_commission: 0.0,
				views: 0,
				affiliate_commission_avg: 0,
				purchase_view_rate: 0,
				purchases_approved_rate: 0,
				earn_per_click: 0,
			},

			// --- DADOS DE VENDAS (PURCHASES) ---
			purchaseTotalLoading: false,
			purchasesDataLoading: false,
			totalPurchases: 0,
			purchasesItems: [],
			includeMgfKeysPurchases: false,
			purchasesPagination: {
				sortBy: 'datetime',
				descending: true,
				page: 1,
				rowsPerPage: 10,
			},
			totalByStatus: {
				issued: 0,
				approved: 0,
				cancelled: 0,
				denied: 0,
				denied_cancelled: 0,
				reversals: 0,
			},
			csvAttrNames: [
				'dtstring',
				'advertiser_name',
				'campaign_name',
				'value_string',
				'affiliate_commission_string',
				'status_string',
				'ref_order',
				'mgf_keys',
			],
			csvColumnNames: [
				'Data/hora',
				'Anunciante',
				'Campanha',
				'Valor',
				'Comissao',
				'Estado',
				'Ref. Magazord',
				'Chaves MGF',
			],

			// --- DADOS DE VISITAS (VISITS) ---
			visitsDataLoading: false,
			totalVisits: 0,
			visitsItems: [],
			includeMgfKeysVisits: false,
			visitsPagination: {
				sortBy: 'datetime',
				descending: true,
				page: 1,
				rowsPerPage: 10,
			},
		}
	},
	computed: {
		affiliate: function () {
			return (this.$root.affiliate && Object.keys(this.$root.affiliate).length > 0)
				? this.$root.affiliate
				: {}
		},
		advertiserList: function () {
			let advertiserList = this.$root.advertiserList
			if (!Array.isArray(advertiserList) || !advertiserList.length) return []
			return advertiserList
		},
		rootSelectedAdvertisers: function () {
			return (
				(this.$root.selectedAdvertisers &&
					Object.values(this.$root.selectedAdvertisers)) ||
				[]
			)
		},
		downloadableData: function () {
			return this.fetch_all_purchases
		},
		csvFileName: function () {
			return (
				'magafilio_conversoes_' +
				this.startDate.format('YYYYMMDDHHmmss') +
				'_' +
				this.endDate.format('YYYYMMDDHHmmss')
			)
		},
		purchasesHeaders: function () {
			let headers = [
				{ text: 'Data/hora', align: 'left', value: 'datetime', width: '13%' },
				{ text: 'Anunciante', value: 'advertiser.register.reg_name', width: '15%' },
				{ text: 'Campanha', value: 'campaign.reg_name', width: '15%' },
				{ text: 'Valor', value: 'value', width: '15%' },
				{ text: 'Comissão', value: 'affiliate_commission', width: '10%' },
				{ text: 'Estado', value: 'status', width: '10%' },
				{ text: 'Ref.', value: 'ref_order', width: '10%' },
			]
			if (this.includeMgfKeysPurchases) {
				headers.push({ text: 'Chaves MGF', value: 'mgf_keys', width: '10%' })
			}
			return headers
		},
		visitsHeaders: function () {
			let headers = [
				{ text: 'Data/hora', align: 'left', value: 'datetime', width: '20%' },
				{ text: 'Anunciante', value: 'advertiser', width: '20%' },
				{ text: 'Campanha', value: 'campaign', width: '25%' },
				{ text: 'URI', value: 'ref_uri', width: '35%' },
			]
			if (this.includeMgfKeysVisits) {
				headers[0].width = '10%'
				headers[1].width = '25%'
				headers[2].width = '15%'
				headers[3].width = '40%'
				headers.push({ text: 'Chaves MGF', value: 'mgf_keys', width: '15%' })
			}
			return headers
		},
	},
	methods: {
		// --- MÉTODO PRINCIPAL ---
		load_all_reports: async function () {
			this.loading = true
			this.initialReportGenerated = true // Marca que a primeira busca foi feita
			this.canRefresh = false // Desabilita watchers de paginação durante a carga total

			// Reseta dados da paginação para evitar requests antigos
			this.purchasesPagination.page = 1
			this.visitsPagination.page = 1

			try {
				await Promise.all([
					this.load_aff_summary(),
					this.load_purchases_total(),
					this.load_purchases(),
					this.load_visits()
				])
			} catch (err) {
				this.$notify({
					type: 'error',
					title: 'Ocorreu um problema ao gerar o relatório completo!',
					text: err.message
				})
			}

			this.loading = false
			this.canRefresh = true // Habilita watchers de paginação
		},

		// --- MÉTODOS DO DASHBOARD ---
		load_aff_summary: async function () {
			if (this.affiliate._id) {
				try {
					const query = this.build_base_query() // Usa query base

					let summary = await this.get_summary(this.affiliate._id, {
						start_date: query.start_date,
						end_date: query.end_date,
						advs: query.advs, // Passa os anunciantes
						rnd: Math.random(),
					})
					this.affSummaryRaw = summary.data
				} catch (err) {
					this.$notify({
						type: 'error',
						title: 'Erro ao carregar sumário do Dashboard.',
					})
				}
			}
		},
		formate_percent_value: function (value) {
			if (typeof value !== 'number') return '0.00%'
			return value.toFixed(2) + '%'
		},

		// --- MÉTODOS DE VENDAS (PURCHASES) ---
		load_purchases_total: async function () {
			this.purchaseTotalLoading = true
			const baseQuery = this.build_purchases_query() // Usa query de purchases (com status)

			try {
				const result = await this.get_transactions_total(
					this.affiliate._id,
					baseQuery
				)

				const dataPurchases =
					result && result.data && result.data[0] && result.data[0].purchases
				const dataReversals =
					result && result.data && result.data[0] && result.data[0].reversals

				var total = {
					issued: 0,
					approved: 0,
					cancelled: 0,
					denied: 0,
					denied_cancelled: 0,
					reversals: dataReversals || 0,
				}

				if (dataPurchases) {
					var contPurchases = dataPurchases.reduce(
						(acc, { _id, affiliate_commission }) => ({
							...acc,
							[_id]: affiliate_commission,
						}),
						{}
					)
					contPurchases.denied_cancelled =
						(contPurchases.cancelled || 0) + (contPurchases.denied || 0)
				}

				this.totalByStatus = {
					...total,
					...contPurchases,
				}
			} catch (err) {
				this.$notify({
					type: 'error',
					title: 'Erro ao carregar totais de vendas.',
				})
				this.totalByStatus = { issued: 0, approved: 0, cancelled: 0, denied: 0, denied_cancelled: 0, reversals: 0 }
			}

			this.purchaseTotalLoading = false
		},
		load_purchases: async function () {
			this.purchasesDataLoading = true
			let mgfKeysDetected = false
			let baseQuery = this.build_purchases_query() // Usa query de purchases (com status)
			let query = {
				...baseQuery,
				start: this.purchasesPagination.page,
				limit: this.purchasesPagination.rowsPerPage,
				type: ['purchase', 'reversal'],
				sort_by: this.purchasesPagination.sortBy,
				sort_dir: this.purchasesPagination.descending ? 'desc' : 'asc',
			}

			try {
				const purchases = await this.get_transactions(this.affiliate._id, query)

				purchases.data.entries = purchases.data.entries.map((purchase) => {
					purchase.campaign_name = purchase.campaign.reg_name
					purchase.advertiser_name = purchase.advertiser.register.reg_name
					purchase.dtstring = new Date(purchase.datetime).toLocaleString()
					purchase.value_string = this.to_reais(+purchase.value)
					purchase.affiliate_commission_string = this.to_reais(
						+purchase.affiliate_commission
					)

					if (purchase.type === 'reversal') {
						purchase.status_string = 'Estornado'
					} else {
						const statusKey = this.statusDict.findIndex(
							({ id }) => id === purchase.status
						)
						let statusLabel = statusKey > -1 ? this.statusDict[statusKey].name : purchase.status
						purchase.status_string = statusLabel
					}

					if ('mgf_keys' in purchase) {
						mgfKeysDetected = true
					}
					return purchase
				})

				this.purchasesItems = purchases.data.entries
				this.totalPurchases = purchases.data.total
				this.includeMgfKeysPurchases = mgfKeysDetected
			} catch (err) {
				this.$notify({
					type: 'error',
					title: 'Erro ao carregar lista de vendas.',
				})
				this.purchasesItems = []
				this.totalPurchases = 0
			}

			this.purchasesDataLoading = false
		},
		fetch_all_purchases: async function () {
			this.purchasesDataLoading = true
			let mgfKeysDetected = false
			let baseQuery = this.build_purchases_query()
			let query = {
				...baseQuery,
				start: 1, // Começa da página 1
				limit: this.totalPurchases || 500, // Baixa todos ou um limite
				type: ['purchase', 'reversal'],
				sort_by: this.purchasesPagination.sortBy,
				sort_dir: this.purchasesPagination.descending ? 'desc' : 'asc',
			}

			try {
				const purchases = await this.get_transactions(this.affiliate._id, query)
				purchases.data.entries = purchases.data.entries.map((purchase) => {
					purchase.campaign_name = purchase.campaign.reg_name
					purchase.advertiser_name = purchase.advertiser.register.reg_name
					purchase.dtstring = new Date(purchase.datetime).toLocaleString()
					purchase.value_string = String(purchase.value.toFixed(2))
					purchase.affiliate_commission_string = String(purchase.affiliate_commission.toFixed(2))

					if (purchase.type === 'reversal') {
						purchase.status_string = 'Estornado'
					} else {
						const statusKey = this.statusDict.findIndex(
							({ id }) => id === purchase.status
						)
						let statusLabel = statusKey > -1 ? this.statusDict[statusKey].name : purchase.status
						purchase.status_string = statusLabel
					}

					if ('mgf_keys' in purchase) {
						mgfKeysDetected = true
					}
					return purchase
				})
				this.includeMgfKeysPurchases = mgfKeysDetected
				this.purchasesDataLoading = false
				return purchases.data.entries
			} catch (err) {
				this.$notify({
					type: 'error',
					title: 'Erro ao baixar CSV de vendas.',
				})
				this.purchasesDataLoading = false
				return []
			}
		},

		// --- MÉTODOS DE VISITAS (VISITS) ---
		load_visits: async function () {
			if (!this.affiliate._id) return

			this.visitsDataLoading = true
			const baseQuery = this.build_base_query() // Usa query base
			let query = {
				...baseQuery,
				start: this.visitsPagination.page,
				limit: this.visitsPagination.rowsPerPage,
				type: 'view',
				sort_by: this.visitsPagination.sortBy,
				sort_dir: this.visitsPagination.descending ? 'desc' : 'asc',
			}

			try {
				const visits = await this.fetch_visits(this.affiliate._id, query)
				this.visitsItems = visits.data.entries
				this.totalVisits = visits.data.total
			} catch (err) {
				this.$notify({
					type: 'error',
					title: 'Erro ao carregar visitas.',
				})
				this.visitsItems = []
				this.totalVisits = 0
			}
			this.visitsDataLoading = false
		},
		fetch_visits: async function (aff_id, query) {
			let visits = await this.get_transactions(aff_id, query)
			let mgfKeysDetected = false
			visits.data.entries = visits.data.entries.map((visit) => {
				visit.dtstring = new Date(visit.datetime).toLocaleString()
				visit.campaign_name = visit.campaign.reg_name
				visit.advertiser_name = visit.advertiser.register.reg_name

				if (typeof visit.mgf_keys !== 'undefined') {
					mgfKeysDetected = true
				}
				return visit
			})
			this.includeMgfKeysVisits = mgfKeysDetected
			return visits
		},


		// --- MÉTODOS HELPER ---
		date_range_select: function (range) {
			if (this.startDate != range.startDate || this.endDate != range.endDate) {
				this.startDate = range.startDate
				this.endDate = range.endDate
			}
		},
		custom_sort: function (items, index, isDescending) {
			items.sort((a, b) => {
				if (isDescending) {
					return a[index] > b[index] ? 1 : -1
				} else {
					return b[index] > a[index] ? 1 : -1
				}
			})
			return items
		},
		add_thousands_sep(x) {
			var parts = x.toString().split(',')
			parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
			return parts.join(',')
		},
		to_reais: function (value, dec_places = 2) {
			if (typeof value !== 'number') value = 0.0
			return (
				'R$' +
				this.add_thousands_sep(value.toFixed(dec_places).replace('.', ','))
			)
		},
		build_base_query: function () {
			let query = {
				start_date: this.startDate.toISOString(),
				end_date: this.endDate.toISOString(),
			}

			// Se anunciantes selecionados, usa. Senão, usa todos.
			if (this.selectedAdvertisers.length > 0) {
				query.advs = this.selectedAdvertisers.reduce(
					(acc, { _id }) => [...acc, _id],
					[]
				)
			}
			return query
		},
		build_purchases_query: function () {
			// Começa com a query base (data e anunciantes)
			let query = this.build_base_query()

			// Adiciona o filtro de Status (específico de purchases)
			if (Array.isArray(this.selectedStatus) && this.selectedStatus.length) {
				query.status = this.selectedStatus.reduce(
					(acc, { id }) => [...acc, id],
					[]
				)
			}
			return query
		},
		getStatusColor(statusString) {
			switch (statusString) {
			case 'Aprovado':
				return '#40DA99' // Verde
			case 'Pendente':
				return '#5191F2' // Azul
			case 'Cancelado':
				return '#EA4D4D' // Vermelho
			case 'Estornado':
				return '#F6851D' // Laranja
			default:
				return '#c6c6c6' // Cor padrão (claro)
			}
		}
	},
	watch: {
		// --- WATCHERS GERAIS ---
		startDate: function () {
			this.$root.period.startDate = this.startDate
		},
		endDate: function () {
			this.$root.period.endDate = this.endDate
		},
		selectedAdvertisers: async function () {
			this.$root.selectedAdvertisers = this.selectedAdvertisers
		},
		// --- WATCHERS DE PAGINAÇÃO ---
		purchasesPagination: {
			async handler() {
				if (!this.canRefresh || this.loading || this.purchasesDataLoading) return
				await this.load_purchases()
			},
			deep: true,
		},
		visitsPagination: {
			async handler() {
				if (!this.canRefresh || this.loading || this.visitsDataLoading) return
				await this.load_visits()
			},
			deep: true,
		},
	},
	created: async function () {
		if (
			this.$root.selectedAdvertisers &&
			this.$root.selectedAdvertisers.length
		) {
			this.selectedAdvertisers = this.$root.selectedAdvertisers
		}

		this.startDate = (this.$root.period && this.$root.period.startDate) || this.startDate
		this.endDate = (this.$root.period && this.$root.period.endDate) || this.endDate

		// Gera o relatório na primeira carga
		// await this.load_all_reports();
	}
}
</script>

<style>
/* --- ESTILOS GERAIS DO COMBINED REPORT --- */
div.combined-report {
	margin: 55px 10px 95px 10px;
}

/* Ocupa 100% do espaço à direita do menu lateral */
.div-container-combined {
	padding-left: 20px !important;
	width: 100% !important;
	max-width: 100% !important;
}

.full-width-report-table {
	width: 100% !important;
	margin-right: 0 !important;
}

.div-container-combined .div-container-selects {
	margin-top: 25px;
	padding: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.div-container-combined .div-container-selects .div-container-filters {
	width: 80%;
	margin-right: 20px;
}

.div-container-combined .div-loading-circle {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 80vh;
}

.div-container-combined .div-loading-circle circle.v-progress-circular__overlay {
	color: #40DA99 !important;
}

h2.report-section-title {
	font-size: 24px;
	font-weight: 500;
	margin-left: 10px;
	margin-top: 20px;
	margin-bottom: 10px;
	border-bottom: 2px solid #40DA99;
	padding-bottom: 5px;
	display: inline-block;
}

/* --- ESTILOS DOS FILTROS (Comum a todos) --- */
.div-container-combined .div-container-selects .div-container-filters .v-input__prepend-outer {
	margin-top: 12px;
}

.div-container-combined .div-container-selects .div-container-filters .v-input__slot {
	padding: 0 12px;
}

.div-container-combined .div-container-selects .div-container-filters .v-input__slot .v-text-field__slot {
	padding-top: 5px;
}

.div-container-combined .div-container-selects .div-container-filters .v-input__slot .v-label.v-label--active.theme--light {
	top: -2px;
	left: -3px !important;
}

.div-container-combined .v-menu__activator .v-input.v-text-field.v-input--is-label-active.v-input--is-dirty.v-input--is-focused.v-input--is-readonly.theme--light.primary--text .v-input__prepend-outer i {
	color: #40DA99 !important;
}

.div-container-combined .div-container-filters .v-input__icon.v-input__icon--prepend .v-icon.material-icons.theme--light {
	color: #40DA99 !important;
}

.div-container-combined .v-input.v-text-field.v-select.v-input--is-label-active.v-input--is-dirty.theme--light {
	margin-top: 14px;
}


/* --- BOTÃO GERAR RELATÓRIO --- */
.div-container-combined .div-container-filters-button button.button-generate-note {
	border-radius: 13px;
	margin-right: 10px;
	display: flex;
	align-items: center;
	flex-direction: column;
	padding: 12px;
	transform: opacity 0.2s;
	border: none;
}

.theme--dark .div-container-combined .div-container-filters-button button.button-generate-note {
	background: #2D2F32;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
}

.theme--light .div-container-combined .div-container-filters-button button.button-generate-note {
	background: #FFFFFF;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.div-container-combined .div-container-filters-button button.button-generate-note:hover {
	opacity: 0.5;
}

.div-container-combined .div-container-filters-button button.button-generate-note:disabled {
	opacity: 0.4;
	cursor: not-allowed;
}

.div-container-combined .div-container-filters-button button.button-generate-note p {
	margin: 0px;
	font-size: 14px;
}

.div-container-combined .div-container-filters-button button.button-generate-note .v-icon.material-icons-outlined.material-icons {
	margin-bottom: 5px;
	color: #40DA99 !important;
}


/* --- ESTILOS VENDAS (PURCHASES) --- */
.div-container-card-purchases-one,
.div-container-card-purchases-two,
.div-container-card-purchases-three,
.div-container-card-purchases-four {
	border-radius: 13px;
	padding: 12px;
}

.theme--dark .div-container-card-purchases-one,
.theme--dark .div-container-card-purchases-two,
.theme--dark .div-container-card-purchases-three,
.theme--dark .div-container-card-purchases-four {
	background: #2D2F32;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
}

.theme--light .div-container-card-purchases-one,
.theme--light .div-container-card-purchases-two,
.theme--light .div-container-card-purchases-three,
.theme--light .div-container-card-purchases-four {
	background: #FFFFFF;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.div-container-card-purchases-one,
.div-container-card-purchases-two {
	margin-bottom: 13px;
	margin-top: 15px;
}

.div-container-card-purchases-one,
.div-container-card-purchases-three {
	margin-right: 13px;
	margin-left: 10px;
}

.div-container-card-purchases-two,
.div-container-card-purchases-four {
	margin-right: 23px;
}

.div-container-card-purchases-one p.paragrafo-title,
.div-container-card-purchases-two p.paragrafo-title,
.div-container-card-purchases-three p.paragrafo-title,
.div-container-card-purchases-four p.paragrafo-title {
	font-size: 16px;
	font-weight: 500;
	margin: 0px;
}

.div-container-card-purchases-one p.paragrafo-subtitle,
.div-container-card-purchases-two p.paragrafo-subtitle,
.div-container-card-purchases-three p.paragrafo-subtitle,
.div-container-card-purchases-four p.paragrafo-subtitle {
	font-size: 11px;
	margin: 0px 0px 5px 0px;
	opacity: 0.7;
}

.div-container-card-purchases-one p.paragrafo-value {
	font-size: 22px;
	margin: 0px;
	color: #40DA99 !important;
}

.div-container-card-purchases-two p.paragrafo-value {
	font-size: 22px;
	margin: 0px;
	color: #5191F2 !important;
}

.div-container-card-purchases-three p.paragrafo-value {
	font-size: 22px;
	margin: 0px;
	color: #EA4D4D !important;
}

.div-container-card-purchases-four p.paragrafo-value {
	font-size: 22px;
	margin: 0px;
	color: #F6851D !important;
}

/* Tabela Purchases */
.div-container-dataTable-purchases {
	margin-top: 15px;
	margin-right: 23px;
	margin-left: 10px;
	width: 100% !important;
	margin-right: 0 !important;
}

.theme--dark .div-container-dataTable-purchases .v-datatable.v-table {
	background: #2D2F32 !important;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
	border-radius: 13px 13px 0px 0px;
}

.theme--dark .div-container-dataTable-purchases .v-datatable__actions {
	background: #2D2F32 !important;
}

.theme--dark .div-container-dataTable-purchases .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
	background: rgba(0, 0, 0, 0.5);
}

.theme--light .div-container-dataTable-purchases .v-datatable.v-table {
	background: #FFFFFF !important;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
	border-radius: 13px 13px 0px 0px;
}

.theme--light .div-container-dataTable-purchases .v-datatable__actions {
	background: #FFFFFF !important;
}

.div-container-dataTable-purchases .v-datatable__actions .v-select__slot {
	padding: 0px 12px;
}

.div-container-dataTable-purchases .v-progress-linear .primary {
	background-color: #40DA99 !important;
}


/* --- ESTILOS VISITAS (VISITS) --- */
.div-container-card-quant-visits {
	border-radius: 13px;
	margin: 15px 23px 0px 10px;
	/* Ajustado margin-left */
	padding: 12px;
}

.theme--dark .div-container-card-quant-visits {
	background: #2D2F32;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
}

.theme--light .div-container-card-quant-visits {
	background: #FFFFFF;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
}

div.div-container-card-quant-visits p.paragrafo-title {
	font-size: 18px;
	font-weight: 500;
	margin: 0px;
}

div.div-container-card-quant-visits p.paragrafo-subtitle {
	font-size: 11px;
	margin: 0px 0px 5px 0px;
	opacity: 0.7;
}

div.div-container-card-quant-visits p.paragrafo-value {
	font-size: 22px;
	margin: 0px;
	color: #40DA99 !important;
}

/* Tabela Visits */
.div-container-dataTable-visits {
	margin-top: 15px;
	/* Ajustado */
	margin-right: 23px;
	/* Ajustado */
	margin-left: 10px;
	/* Ajustado */
	width: 100% !important;
	margin-right: 0 !important;
}

.theme--dark .div-container-dataTable-visits .v-datatable.v-table {
	background: #2D2F32 !important;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
	border-radius: 13px 13px 0px 0px;
}

.theme--dark .div-container-dataTable-visits .v-datatable__actions {
	background: #2D2F32 !important;
}

.theme--dark .div-container-dataTable-visits .v-table tbody tr:hover:not(.v-datatable__expand-row) {
	background: rgba(0, 0, 0, 0.5) !important;
}

.theme--light .div-container-dataTable-visits .v-datatable.v-table {
	background: #FFFFFF !important;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
	border-radius: 13px 13px 0px 0px;
}

.theme--light .div-container-dataTable-visits .v-datatable__actions {
	background: #FFFFFF !important;
}

.theme--light .div-container-dataTable-visits .v-table tbody tr:hover:not(.v-datatable__expand-row) {
	background: #F5F5F5 !important;
}

.div-container-dataTable-visits .v-datatable__actions .v-select__slot {
	padding: 0px 12px;
}

.div-container-dataTable-visits .v-progress-linear .primary {
	background-color: #40DA99 !important;
}


/* --- ESTILOS DASHBOARD --- */
.div-container-view {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 15px;
	border-radius: 13px;
	margin-right: 20px;
	margin-left: 10px;
	padding: 12px 12px 0px 12px;
}

.theme--dark .div-container-view {
	background: #2D2F32;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
}

.theme--light .div-container-view {
	background: #FFFFFF;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.div-container-view .div-container-boxOne div p.paragrafo-title,
.div-container-view .div-container-boxTwo div p.paragrafo-title {
	font-size: 18px;
	font-weight: 500;
	margin: 0px;
}

.div-container-view .div-container-boxOne div p.paragrafo-subtitle,
.div-container-view .div-container-boxTwo div p.paragrafo-subtitle {
	font-size: 11px;
	margin: 0px 0px 5px 0px;
	opacity: 0.7;
}

.div-container-view .div-container-boxOne div p.paragrafo-price-approved,
.div-container-view .div-container-boxTwo div p.paragrafo-price-approved {
	font-size: 22px;
	margin-bottom: 25px;
	color: #40DA99 !important;
}

.div-container-view .div-container-boxOne div p.paragrafo-price-issued,
.div-container-view .div-container-boxTwo div p.paragrafo-price-issued {
	font-size: 22px;
	margin-bottom: 25px;
	color: #5191F2 !important;
}

.div-container-view .div-container-boxTwo div p.paragrafo-price-reversal {
	font-size: 22px;
	margin-bottom: 25px;
	color: #F6851D !important;
}

/* --- CHIPS (TAGS) DO SELECT --- */
.theme--dark .div-container-combined .div-container-selects .div-container-filters .v-chip.v-chip--small {
	background: #2D2F32 !important;
	border: 1px solid #c6c6c6;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
}

.theme--light .div-container-combined .div-container-selects .div-container-filters .v-chip.v-chip--small {
	background: #F5F5F5 !important;
	border: none;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.theme--light .div-container-combined .div-container-selects .div-container-filters .v-chip.v-chip--small .v-chip__content {
	color: #212121 !important;
}

@media (max-width: 961px) {
	.div-container-combined {
		margin: auto !important;
		width: 100%;
		padding-left: 0 !important;
	}
}

@media (max-width: 800px) {
	.div-container-view {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
	}
}

@media (max-width: 600px) {

	.div-container-card-purchases-one,
	.div-container-card-purchases-two,
	.div-container-card-purchases-three,
	.div-container-card-purchases-four {
		margin: 10px 22px 10px 10px;
	}
}

@media (min-width: 600px) {

	.menu-column {
		flex: 0 0 215px !important;
		max-width: 215px !important;
	}

	.div-container-combined {
		flex: 1 !important;
		max-width: calc(100% - 215px) !important;
		width: auto !important;
	}
}

/* Remove a borda/cor do mês/dia atual se ele não estiver selecionado */
.v-date-picker-table .v-btn--outline {
	border: none !important;
	background-color: transparent !important;
	color: inherit !important;
}

/* Garante que o item selecionado tenha a cor correta */
.v-date-picker-table .v-btn--active {
	background-color: #40DA99 !important;
	color: #fff !important;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Ajuste específico para o tema escuro/claro se necessário */
.theme--light .v-date-picker-table .v-btn--active {
	color: #fff !important;
}
</style>